"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedquestions = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 62 56",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedquestions` : '') + (description ? ` desc-brandedquestions` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedquestions"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedquestions"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M57.38 35.04a19 19 0 1 1-38 0 19 19 0 0 1 38 0Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M51.42 23a23 23 0 1 1-46 0 23 23 0 0 1 46 0Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.78 40.3a1.1 1.1 0 0 1-.95-1.53L6.5 31.2c.33-.67 1.26-.67 1.68 0l4.71 7.6c.42.67.01 1.5-.73 1.5H3.78Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.78 52.25c.73.13 1.4-.61 1.2-1.33l-2.3-8.1c-.2-.72-1.11-.88-1.64-.28l-5.96 6.65c-.53.6-.28 1.5.45 1.62l8.25 1.44Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.42 8.42 13.85 40.8a22.69 22.69 0 0 1-8.43-17.66 23.14 23.14 0 0 1 41-14.72Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m3.84 40.46 9.03-.23c4.3 3.27 9.3 5.56 14.8 5.77 13 .5 23.84-10.08 23.84-22.91-.3-7-3.3-14.5-9.15-18.49-9.44 15.39-23 27.93-39.39 35.3.18.24.36.55.87.56Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.64 13.54c-.8-.06-1.6.11-2.32.52a4.66 4.66 0 0 0-1.78 1.78 5.25 5.25 0 0 0-.68 2.59c0 .82-.67 1.5-1.49 1.5a1.5 1.5 0 0 1-1.5-1.5c0-1.43.38-2.84 1.07-4.07a7.65 7.65 0 0 1 2.93-2.93 7.11 7.11 0 0 1 7.81.57 7.9 7.9 0 0 1 2.52 3.32 8.33 8.33 0 0 1-1.05 8.06 7.48 7.48 0 0 1-3.3 2.48c-.27.11-.53.31-.72.6-.2.29-.3.65-.3 1.02v.55a1.5 1.5 0 1 1-2.98 0v-.55c0-.95.27-1.89.8-2.68a4.5 4.5 0 0 1 2.15-1.74 4.5 4.5 0 0 0 1.98-1.5 5.32 5.32 0 0 0 .66-5.11 4.84 4.84 0 0 0-1.55-2.05 4.23 4.23 0 0 0-2.25-.86Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.34 35.93c.23 0 .43-.1.56-.24a.67.67 0 0 0 0-.92.77.77 0 0 0-.56-.24v-1.6c-.63 0-1.2.26-1.62.7a2.34 2.34 0 0 0 0 3.19c.41.44 1 .7 1.62.7v-1.6Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.34 32.93c.62 0 1.2.26 1.61.7a2.33 2.33 0 0 1 0 3.19c-.4.44-.99.7-1.61.7v-1.6a.77.77 0 0 1-.56-.23.67.67 0 0 1-.19-.46c0-.16.06-.33.19-.46a.77.77 0 0 1 .56-.24v-1.6Z",
    fill: "#FFF5EB"
  }));
};
var _default = exports.default = brandedquestions;